import React from 'react';

import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { UploadPlanSetField } from 'modules/components/layer04';


export type SavePlanSetPlansFormProps = {
  planSetId: string;
  projectId: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePlanSetPlansFormProps) => {

  const form = ds.useFormState(props.planSetId ?? '', props.projectId ?? '');

  const handleSubmit = async () => {
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => {
        props.handleClose();
      }}
      handleSubmit={() => {
        handleSubmit();
      }}
      cancelButtonText='Cancel'
      ignoreCancel={true}
      successButtonText='Done'
      isLoading={form.formState.isUploading}
    >
      <UploadPlanSetField.FC
        form={form}
        fieldName='apiFileQueue'
        uploadInProgressFieldName='isUploading'
      />
    </FormBaseLayout.FC>
  );
};
